var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"developer-doc-frame",attrs:{"src":"/doc/","title":"开放文档"}})}
var staticRenderFns = []

export { render, staticRenderFns }